import React from "react";
import { Box, Stack, Text } from "@chakra-ui/react";
import { useAuthContext } from "@/context/AuthContext";
import { ChangePasswordForm } from "@/components/forms/ChangePasswordForm";

const SettingsProfile = () => {
  const { user } = useAuthContext();
  return (
    <Stack p={6}>
      <Box mb={16} gap={4} display={"flex"} flexDirection={"column"}>
        <Text>Organization: {user?.organization?.name ?? ''}</Text>
        <Text>User: {user?.email}</Text>
      </Box>
      <ChangePasswordForm />
    </Stack>
  );
};
export default SettingsProfile;
